import { create } from "zustand";
import type User from "../types/User";
import createSelectors from "./selectors";

export type UserStoreProps = {
  currentUser: User | null;
  permissions: any[];
  setCurrentUser: (currentUser: User) => void;
  setPermissions: (permissions: any[]) => void;
};

const useUserStore = create<UserStoreProps>((set) => ({
  currentUser: null,
  permissions: [],
  setCurrentUser: (currentUser) => set({ currentUser }),
  setPermissions: (permissions: any[]) => set({ permissions }),
}));

export default createSelectors(useUserStore);
